export default {
  setAllBankList: (state, banks) => {
    state.allBanks = banks
  },
}
